import { FC } from 'react'
import { AnimalDto } from '../../../../interactors/gen/backendClient'
import { AnimalHealthCard } from './AnimalHealthCard'
import { AnimalHealthFormAndActivityCard } from './AnimalHealthFormAndActivityCard'
import { AnimalHealthOperationsCard } from './AnimalHealthOperationsCard'
import { Box, Card, CardContent, Grid, Typography, useMediaQuery } from '@mui/material'
import { surfaceCardSx } from '../../../common/surfaceCardSx'

interface Props {
  animal: AnimalDto
}

export const AnimalHealthTab: FC<Props> = ({ animal }) => {
  const isDesktop = useMediaQuery('(min-width:1100px)')

  return (
    <>
      <Grid container spacing={2}>
        {isDesktop ? (
          <Grid item xs={12}>
            <Card sx={{ ...surfaceCardSx, height: '100%' }}>
              <CardContent sx={{ p: 2.25 }}>
                <Typography variant="subtitle1" sx={{ mb: 1.75 }}>
                  🏥 Santé & activité
                </Typography>

                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: 'minmax(0, 1fr) 320px',
                    gap: 2.5,
                    alignItems: 'start',
                  }}
                >
                  <Box sx={{ minWidth: 0 }}>
                    <Typography
                      variant="caption"
                      sx={{ display: 'block', color: '#7A8197', fontWeight: 700, fontSize: 11, mb: 1.25 }}
                    >
                      Santé
                    </Typography>
                    <AnimalHealthCard animal={animal} embedded />
                  </Box>
                  <Box
                    sx={{
                      minWidth: 0,
                      pl: 2.5,
                      borderLeft: '1px solid rgba(228, 232, 242, 0.9)',
                    }}
                  >
                    <Typography
                      variant="caption"
                      sx={{ display: 'block', color: '#7A8197', fontWeight: 700, fontSize: 11, mb: 1.25 }}
                    >
                      Forme & activité
                    </Typography>
                    <AnimalHealthFormAndActivityCard animal={animal} embedded />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ) : (
          <>
            <Grid item xs={12} md={9}>
              <AnimalHealthCard animal={animal} />
            </Grid>
            <Grid item xs={12} md={3}>
              <AnimalHealthFormAndActivityCard animal={animal} />
            </Grid>
          </>
        )}
        <Grid item xs={12} md={12}>
          <AnimalHealthOperationsCard animal={animal} />
        </Grid>
      </Grid>
    </>
  )
}
